import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";

import AddItemDrawer from "../../../components/Rewards/Cart/AddItemDrawer";
import PointsCard from "../../../components/Rewards/PointsCard";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";
import { newFetch, GET, POST } from "../../../helpers/fetch";
import placeholderBackground from "../../../assets/images/placeholder-background.png";

import { config } from "../../../config";

const { SERVER_URL } = config;

const Cart = ({ history }) => {
  const [userPoints, setUserPoints] = useState(0);
  const [cart, setCart] = useState(
    localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : []
  );
  const [total, setTotal] = useState(0);
  const [mailingPoints, setMailingPoints] = useState(0);
  const [activeItem, setActiveItem] = useState(null);
  const [isMailing, setIsMailing] = useState(false);
  const [hasNoMail, setHasNoMail] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchUserPoints = async () => {
    let api_path = "/associate/aboutme";
    let response = await newFetch(GET, api_path);

    if (response.success && response.data.new_reward_points) {
      let new_reward_points = response.data.new_reward_points;
      //setUserPoints(reward_points.points);
      const total = associatePointsHandler(new_reward_points);
      setUserPoints(total);
    }
  };

  const associatePointsHandler = (data) => {
    const finalTotalPoints = data.reduce((total, points) => {
      let computedExpiredAndUsePoints =
        parseFloat(points.total_expired) + parseFloat(points.total_used);
      let totalEarnedBalance =
        parseFloat(points.total_earned) - computedExpiredAndUsePoints;

      return total + totalEarnedBalance;
    }, 0);

    return finalTotalPoints;
  };

  const handleDeleteFromCart = async (item_id) => {
    if (
      await AlertService.confirm(
        "",
        "Are you sure you want to remove this item from cart?"
      )
    ) {
      let cloneCart = JSON.parse(JSON.stringify([...cart]));
      let filterCart = cloneCart.filter(
        (cartItem) => cartItem.item_id !== item_id
      );
      setCart(filterCart);
      setHasNoMail(handleMailServiceTrigger(filterCart));
    }
  };

  const handleMailServiceTrigger = (items) => {
    if (items && items.length > 0) {
      let isHasNoMail = false;
      items.map((cartItem) => {
        if (cartItem.item.mailing_cost <= 0) {
          isHasNoMail = true;
        }
      });
      return isHasNoMail;
    }
  };

  const handleCheckout = async () => {
    if (
      await AlertService.confirm("", "Are you sure you want to checkout cart?")
    ) {
      setIsSubmitting(true);

      let checkoutItems = cart.map((cartItem) => ({
        id: cartItem.item_id,
        quantity: cartItem.quantity,
      }));

      let data = {
        items: checkoutItems,
        is_mailing: isMailing,
      };

      let api_path = `/reward/checkout`;
      let response = await newFetch(POST, api_path, data);

      if (response.success) {
        ToastUtil.success(response.message);
        fetchUserPoints();
        setCart([]);
        localStorage.removeItem("cart");
        history.push("/rewards?activeTab=Redeemed");
      } else {
        ToastUtil.error(response.message);
      }

      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (cart && cart.length > 0) {
      setTotal(cart.reduce((total, cartItem) => total + cartItem.subtotal, 0));
      setMailingPoints(
        cart.reduce(
          (total, cartItem) =>
            total + cartItem.item.mailing_cost * cartItem.quantity,
          0
        )
      );
    } else {
      setTotal(0);
    }

    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {}, [mailingPoints]);

  useEffect(() => {
    fetchUserPoints();
  }, []);

  useEffect(() => {
    setHasNoMail(handleMailServiceTrigger(cart));
  }, []);

  return (
    <div
      className="container pt-4"
      style={{ minHeight: "60vh", height: "60vh" }}
    >
      <PointsCard points={userPoints} />

      {cart && cart.length > 0 ? (
        <>
          <div className="d-flex flex-column">
            <div
              id="itemsContainer"
              className="d-flex-flex-column"
              style={{ marginBottom: "7rem" }}
            >
              <h6 className="pb-2">Cart Items</h6>
              {cart.map((cartItem, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center shadow bg-white mb-3 rounded"
                >
                  <div
                    onClick={() =>
                      history.push(`/rewards/item/${cartItem.item.id}`)
                    }
                    className="img-responsive"
                    style={{
                      position: "relative",
                      background: `url(${
                        cartItem.item && cartItem.item.images.length > 0
                          ? `${SERVER_URL}/${cartItem.item.images[0].url}`
                          : placeholderBackground
                      }) no-repeat center center`,
                      backgroundSize: "cover",
                      height: "75px",
                      width: "75px",
                    }}
                  ></div>
                  <div className="d-flex flex-column flex-grow-1 ml-3">
                    <div className="p-0 m-0" style={{ fontSize: "0.9rem" }}>
                      {cartItem.item &&
                        _.truncate(cartItem.item.name, { length: 24 })}
                    </div>
                    <div
                      className="mt-1 text-muted"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Quantity: {cartItem.item && cartItem.quantity}
                    </div>
                    {isMailing && (
                      <div
                        className="text-muted mt-1"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Mailing:{" "}
                        {cartItem.item && cartItem.item.mailing_cost
                          ? cartItem.item.mailing_cost * cartItem.quantity
                          : 0}{" "}
                        POINTS
                      </div>
                    )}
                    <div
                      className="text-brand mt-1"
                      style={{ fontSize: "0.8rem" }}
                    >
                      {cartItem.item && cartItem.item.type === "redeemable"
                        ? `${cartItem.subtotal} POINTS`
                        : "FREE"}
                    </div>
                  </div>
                  <div className="btn-group-vertical">
                    <button
                      onClick={() => setActiveItem(cartItem.item)}
                      className="btn bg-white text-brand rounded-0"
                      style={{ fontSize: "0.8rem" }}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      onClick={() => handleDeleteFromCart(cartItem.item_id)}
                      className="btn bg-white text-secondary rounded-0"
                      style={{ fontSize: "0.8rem" }}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="bg-white"
              style={{
                position: "fixed",
                left: "0",
                bottom: "0",
                width: "100%",
              }}
            >
              <div
                id="totalContainer"
                className="d-flex justify-content-between align-items-center py-2 bg-white rounded container"
              >
                <h6 className="mb-0">Choose option:</h6>
                <div className="d-flex align-items-center">
                  <div
                    className={
                      !isMailing ? "text-brand font-weight-bold" : "text-muted"
                    }
                    onClick={() => setIsMailing(false)}
                  >
                    Self Collect
                  </div>
                  {!hasNoMail && (
                    <React.Fragment>
                      <div className="mx-2">|</div>
                      <div
                        className={
                          isMailing
                            ? "text-brand font-weight-bold"
                            : "text-muted"
                        }
                        onClick={() => setIsMailing(true)}
                      >
                        Mail Service
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>

              <div
                id="totalContainer"
                className="d-flex justify-content-between align-items-center py-2 bg-white rounded container"
              >
                <h5>Total:</h5>
                <h5 className="text-brand ml-2">
                  {isMailing ? total + mailingPoints : total} Points
                </h5>
              </div>

              {userPoints < total && (
                <div className="container text-right mb-2">
                  <small className="text-danger">
                    You have insufficient points.
                  </small>
                </div>
              )}

              <div id="checkoutOption">
                <button
                  className="btn btn-design btn-lg btn-block btn-brand rounded-0"
                  disabled={userPoints < total || isSubmitting}
                  onClick={handleCheckout}
                >
                  Checkout
                </button>
              </div>
            </div>
          </div>
          <AddItemDrawer
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            cart={cart}
            setCart={setCart}
            setHasNoMail={setHasNoMail}
          ></AddItemDrawer>
        </>
      ) : (
        <div className="h-100 d-flex justify-content-center align-items-center">
          <h4 className="text-center">Cart is empty.</h4>
        </div>
      )}
    </div>
  );
};

export default withRouter(Cart);
